import { lazy } from 'react'
import { registerEditor } from '../editor-registry.js'

const LazyMarkdownEditor = lazy(() =>
  import('../../ui/MarkdownEditor.js').then(m => ({ default: m.MarkdownEditor }))
)

registerEditor({
  notifiesFileGone: true, // #823: FileStateBanner, from the room's close
  family: 'text',
  extensions: ['md', 'txt', 'json', 'pmeta'],
  name: 'Markdown Editor',
  component: LazyMarkdownEditor,
  maxEditableSize: 1024 * 1024, // 1 MB
})
